import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import {
  useAllPositionList,
  useEmployeeListData,
  useGetOrgUnitsData,
  useGetPositionListNew,
} from "./hooks/useEmployee";
import { FaEdit, FaEye } from "react-icons/fa";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import PositionModal from "./components/PositionModal";


type Props = {};
const HeaderContent = (props: any) => {
  const handleFilter = (key: any, selected: any) => {
    props?.setFiltersState((prev: any) => ({
      ...prev,
      [key]: selected.id === "null" ? null : Number(selected.id),
    }));
  };

  return (
    <div
      style={{
        marginBottom: "15px",
        gap: "10px",
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <RoundedDropdown
        options={props?.orgUnitsList || []}
        onSelect={(e) => {
          handleFilter("orgUnits", e);
        }}
        defaultLabel="All"
        width="auto"
        isShowHeading
        DropdownHeading="Org Unit"
        headingColor="#2e8dd3"
      />
     
      
    </div>
  );
};

const Position = (props: Props) => {
  const [positionSearchTerm, setPositionSearchTerm] = useState("");
  const [positionPage, setPositionPage] = useState(1);
  const [isModalOpen,setIsModalOpen]=useState(false)
  const [refresh,setRefresh]=useState(false)
  const [selectedRow,setSelectedRow]=useState('');
  const [mode,setMode]=useState('')
  
  
  const navigate = useNavigate();
  const { data: orgUnitsList } = useGetOrgUnitsData({ enable: true });


  const [filtersState, setFiltersState] = useState<any>({
    orgUnits: null,
    gradeMaster: null,
    designation: null,
    status: null,
    limit: 10,
    page: 1,
    search: null,
    Position:null,
  });

  console.log('filtersatetessss',filtersState)
  

  const { data: PositionList,isLoading } = useGetPositionListNew({
    params: {
      orgUnitId: filtersState?.orgUnits,
      // fetch:'all'
      start: filtersState?.page,
      length: filtersState?.limit,
      search:filtersState?.search
    },
    enabled: !!orgUnitsList,
  });

  console.log('poistionList',PositionList?.data)


  const PositionListColumns = (handleEditPosition:(row:any)=>void,handlePositionView: (row: any) => void,) => [
    {
      name: "Position Id",
      selector: (row: { PositionId: number | string }) =>
        row.PositionId || "-",
      sortable: true,
      minWidth:'130px',
      wrap:true
    
      
    },
    {
      name: "Position Name",
      selector: (row: { PositionName: string }) =>
       
        row.PositionName|| "-"
      ,
      sortable: true,
      minWidth:'150px',wrap:true

    },
    {
      name: "Position Code",
      selector: (row: { PositionCode: string }) => row?.PositionCode || "-", // (depend by backend)
      sortable: true,
      minWidth:'150px',
      wrap:true

    },
    {
      name: "Reporting To",
      selector: (row: { ReportingToDetail?: { PositionName?: string } }) => row?.ReportingToDetail?.PositionName || "-", // (depend by backend)
      sortable: true,
      minWidth:'150px',
      wrap:true
    },
    {
      name: "OrgUnit Name",
      selector: (row: { UnitName: string }) => row?.UnitName || "-",
      sortable: true,
         minWidth:'150px',
      wrap:true
    },
    {
      name: "Town(HQ)",
      selector: (row: { GeoTowns?:{Stownname :string }}) => row?.GeoTowns?.Stownname || "-",
      sortable: true,
         minWidth:'130px',
      wrap:true
    },
    {
      name: "Actions",
      minWidth:'150px',
      cell: (row: any) => (
        <button
          onClick={() => handleEditPosition(row)}
          className="btn btn-primary"
          style={{ borderRadius: "20px", padding: "5px", width: "80px" }}
        >
          <FaEdit style={{ fill: "#fff" }} /> Edit
        </button>
      ),
    },
  ];

  // console.log('employeeStatus',employeeStatus?.['response'])

  const handlePositionView = (row: any) => {
    setSelectedRow(row);
    toggleModal()
  };

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };

    const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };


  const handleAddEmployee=()=>{
    setMode('add')
setIsModalOpen(true)
  }  
  const handleEditPosition=(e:any)=>{
    setSelectedRow(e)
    setMode('edit')
    toggleModal()
  }

const handleExcel = async () => {
  try {
    const appToken = localStorage.getItem("Apptoken") || "";
    const orgUnitId = filtersState?.orgUnits || "";
    const start = filtersState?.page || "";
    const length = filtersState?.limit || "";
    const search = filtersState?.search || "";

    const params = new URLSearchParams();

    // Append only if value exists
    if (orgUnitId) params.append("orgUnitId", orgUnitId);
  
    if (search) params.append("search", search);

    const response = await fetch(
      `https://tspc-development.truesales.in/admin/api/getPositionsListNewExcel?${params.toString()}`,
      {
        method: "GET",
        headers: {
          accept: "application/json",
          apptoken: appToken,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to download Excel file");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "PositionListData.xlsx"; // custom filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading Excel file:", error);
  }
};



  return (
    <div className="p-2">
      <PageHeader title="Position"  buttons={[
           {
             label: "+Add Position",
             onClick: handleAddEmployee,
             color:'#2e8dd3'
           },
              {
            label: "Excel",
            onClick:handleExcel,
            color: "#43B9B2",
           }
           ]} />
      <BasicDataTable
      dynamicHeightOnRowsPerPage={true}
      showSpinner={isLoading}
        paginationTotalRows={PositionList?.data?.recordsTotal}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        Title="Position List"
        columns={PositionListColumns(handleEditPosition,handlePositionView)}
        data={PositionList?.data?.data || []}
        headerContent={
          <HeaderContent
           
            orgUnitsList={orgUnitsList?.data}
            setFiltersState={setFiltersState}

          />
        }
      />

      <RouteModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        title={mode=='add'?'Add Position':'Edit Position'}
        size="lg"
        content={
          <PositionModal
            toggle={toggleModal}
            refresh={refresh}
            setRefresh={setRefresh}
            mode={mode}
            selectedRow={selectedRow}
            setIsModalOpen={setIsModalOpen}
          />
        }
      />
    </div>
  );
};

export default Position;
